

import templateForgotPasswordPage from '@/app-template/lib/pages/ForgotPasswordPage.vue';

export default {
  name: "ForgotPasswordPage",
  components: { templateForgotPasswordPage },
};
